import React from 'react';

// Empty component that doesn't render anything
const DemoModeIndicator: React.FC = () => {
  return null;
};

export default DemoModeIndicator;